import { useScrollReveal } from '../../../hooks/useScrollReveal';

const services = [
  {
    icon: 'ri-palette-line',
    title: 'Design graphique',
    description:
      'Création de visuels et supports de communication adaptés à votre image. Affiches, brochures, visuels digitaux — chaque support est conçu avec précision et cohérence.',
    tag: '01',
  },
  {
    icon: 'ri-brush-2-line',
    title: 'Identité visuelle',
    description:
      'Développement d\'une image de marque cohérente et durable. Logo, charte graphique, typographie — tout est pensé pour refléter votre positionnement et vos valeurs.',
    tag: '02',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Conception créative',
    description:
      'Création de concepts visuels personnalisés, sur-mesure pour chaque client. Une approche créative et structurée pour des solutions à la fois esthétiques et efficaces.',
    tag: '03',
  },
];

export default function ServicesSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="services" className="bg-white py-24 md:py-32 px-6 md:px-10 lg:px-16">
      <div ref={ref}>
        {/* Header */}
        <div
          className={`flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-px bg-gray-300" />
              <span
                className="text-xs tracking-widest uppercase text-gray-400"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Services
              </span>
            </div>
            <h2
              style={{
                fontFamily: 'Cormorant Garamond, serif',
                fontWeight: 300,
                fontSize: 'clamp(32px, 4vw, 52px)',
                color: '#1A1A1A',
                lineHeight: '1.1',
              }}
            >
              Ce que nous<br />
              <em style={{ fontStyle: 'italic' }}>créons</em> pour vous
            </h2>
          </div>
          <p
            className="max-w-xs text-sm text-gray-500 leading-relaxed"
            style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
          >
            Chaque projet est abordé avec attention et rigueur, pour des solutions visuelles adaptées à vos besoins.
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service, i) => (
            <div
              key={service.title}
              className={`group border border-gray-100 p-8 md:p-10 hover:border-gray-300 transition-all duration-500 rounded-lg ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${i * 120 + 200}ms` }}
            >
              <div className="flex items-start justify-between mb-8">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-gray-400 group-hover:text-gray-800 transition-colors duration-300`} />
                </div>
                <span
                  className="text-xs text-gray-200 group-hover:text-gray-400 transition-colors duration-300"
                  style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: '18px', fontWeight: 300 }}
                >
                  {service.tag}
                </span>
              </div>
              <h3
                className="mb-4 text-gray-900"
                style={{
                  fontFamily: 'Cormorant Garamond, serif',
                  fontWeight: 500,
                  fontSize: '22px',
                  lineHeight: '1.2',
                }}
              >
                {service.title}
              </h3>
              <p
                className="text-sm text-gray-500 leading-relaxed"
                style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300 }}
              >
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
